import React from "react";

/**
 * MallHero.jsx
 * - Uses the uploaded local image at:
 *   /mnt/data/Screenshot 2025-11-16 151840.png
 * - Pure CSS, no JS
 */
const HERO_BG = "https://i.postimg.cc/t4YRDRbd/6390.jpg";

export default function HeroCard30() {
  return (
    <>
      <header className="mall-hero-wrap" role="banner" aria-label="GrandVista Mall hero">
      

        {/* Hero */}
        <div className="mall-hero">
          <div
            className="mall-bg"
            role="img"
            aria-label="GrandVista Mall building"
            style={{ backgroundImage: `url('${HERO_BG}')` }}
          />

          {/* dark overlay for contrast */}
          <div className="mall-overlay" aria-hidden />

          <div className="mall-content">
            <h1 className="mall-title">
              Discover, Shop, Dine & Enjoy
              <br />
              <span>at GrandVista Mall!</span>
            </h1>

            <p className="mall-sub">
              Experience the ultimate shopping, dining, and entertainment destination
              with top brands, exclusive deals, gourmet cuisine, and endless fun for everyone!
            </p>

            <div className="mall-cta-row">
              <button className="mall-cta-watch" aria-label="Watch video">
                <span className="play-ring" aria-hidden>
                  <span className="play-triangle" />
                </span>
                <span className="watch-text">Watch Video</span>
              </button>
            </div>
          </div>
        </div>

        {/* decorative bottom spacer so next section sits nicely */}
        <div className="mall-hero-bottom" aria-hidden />
      </header>

      <style>{`
/* ---------- base ---------- */
.mall-hero-wrap { font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial; color: #fff;position:relative }

/* ---------- topbar ---------- */
.mall-topbar { position: absolute; inset: 18px 0 auto 0; z-index: 60; pointer-events: none; }
.mall-inner {
  width: min(1220px, 94%);
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 20px;
  pointer-events: auto;
  background: transparent;
  justify-content: space-between;
}

/* brand */
.mall-brand { display:flex; align-items:center; gap:12px; }
.mall-logo {
  width:56px; height:56px; border-radius:10px;
  display:grid; place-items:center;
  background: rgba(255,255,255,0.08); color: #fff;
  font-size: 1.2rem;
  box-shadow: 0 10px 30px rgba(0,0,0,0.25);
}
.mall-name { font-weight:700; font-size:1.05rem; color: rgba(255,255,255,0.95); }

/* nav */
.mall-nav { display:flex; gap:18px; align-items:center; margin-left: 12px; flex:1; justify-content:center; }
.mall-nav a { color: rgba(255,255,255,0.85); text-decoration:none; font-weight:600; padding: 8px 10px; border-radius:6px; transition: all .18s ease; }
.mall-nav a.active, .mall-nav a:hover { color: white; background: rgba(255,255,255,0.06); transform: translateY(-2px); }

/* actions */
.mall-actions { display:flex; gap:10px; align-items:center; }
.mall-buy {
  background: linear-gradient(180deg,#f0b93b,#d89b14);
  color: #111; font-weight:800; border:none; padding:10px 14px; border-radius:8px; cursor:pointer;
  box-shadow: 0 10px 30px rgba(0,0,0,0.25);
}
.mall-profile { background: rgba(255,255,255,0.9); border-radius:10px; border:none; padding:8px 10px; cursor:pointer; }

/* ---------- hero ---------- */
.mall-hero {
  position: relative;padding-top:50px;
  min-height: 78vh;
  display:block;
  overflow:hidden;
}

/* background image (uploaded path used) */
.mall-bg {
  position:absolute; inset:0; z-index:0;
  background-size: cover;
  background-position: center;
  transform: scale(1.03);
  filter: saturate(0.92) contrast(0.9);
}

/* dark overlay to match screenshot */
.mall-overlay {
  position:absolute; inset:0; z-index:1;
  background: linear-gradient(180deg, rgba(6,6,10,0.5) 0%, rgba(6,6,10,0.55) 30%, rgba(6,6,10,0.6) 100%);
}

/* content centered */
.mall-content {
  position: relative;
  z-index: 6;
  width: min(1100px, 92%);
  margin: 0 auto;
  text-align: center;
  padding: calc(6vh) 0;
  display:flex;
  flex-direction:column;
  align-items:center;
  gap: 18px;
}

/* title */
.mall-title {
  font-size: clamp(1.8rem, 4.8vw, 4.0rem);
  font-weight: 900;
  line-height: 1.02;
  margin: 0;
  letter-spacing: -0.02em;
  color: #fff;
  text-shadow: 0 18px 40px rgba(0,0,0,0.45);
}
.mall-title span { display:block; }

/* subtitle */
.mall-sub {
  max-width: 900px;
  margin-top: 6px;
  color: rgba(255,255,255,0.92);
  font-size: clamp(0.95rem, 1.6vw, 1.1rem);
  line-height: 1.6;
  text-shadow: 0 6px 22px rgba(0,0,0,0.35);
}

/* CTA row */
.mall-cta-row { margin-top: 22px; display:flex; align-items:center; gap:18px; }

/* watch video circle */
.mall-cta-watch {
  display:inline-flex;
  align-items:center;
  gap:12px;
  background: transparent;
  border: none;
  color: white;
  cursor:pointer;
  text-decoration: none;
  font-weight:800;
  padding: 8px 14px;
  border-radius: 999px;
}
.play-ring {
  width:76px;
  height:76px;
  border-radius: 50%;
  display: grid;
  place-items:center;
  background: rgba(255,255,255,0.06);
  border: 4px solid rgba(255,255,255,0.18);
  box-shadow: 0 10px 30px rgba(0,0,0,0.35);
  transition: transform .22s ease;
}
.play-ring:hover { transform: scale(1.06); }
.play-triangle {
  width: 0; height: 0;
  border-left: 14px solid white;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  margin-left: 4px;
  filter: drop-shadow(0 4px 14px rgba(0,0,0,0.4));
}
.watch-text { font-size: 1rem; opacity: 0.95; }

/* bottom spacer so next section doesn't overlap hero */
.mall-hero-bottom { height: 60px; background: transparent; }

/* ---------- responsive ---------- */
@media (max-width: 980px) {
  .mall-inner { width: 94%; gap:10px; }
  .mall-nav { display:none; } /* hide center nav on tablet */
  .mall-name { display:none; }
  .mall-content { padding: 8vh 4%; }
  .mall-title { font-size: clamp(1.4rem, 6.4vw, 2.6rem); }
}

@media (max-width: 560px) {
  .mall-inner { padding: 8px 6%; align-items:center; }
  .mall-brand { gap:8px; }
  .mall-content { padding-top: 6vh; }
  .play-ring { width:62px; height:62px; border-width:3px; }
  .play-triangle { border-left: 12px solid white; border-top: 8px solid transparent; border-bottom: 8px solid transparent; }
  .mall-buy { padding:8px 12px; font-size:0.9rem; }
}
      `}</style>
    </>
  );
}
